/* eslint-disable no-unused-vars */
import React  from 'react';

export function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <button className="link-style text-sm text-brand hover:underline">Previous</button>;
  }
  if (type === "next") {
    return <button className="link-style text-sm text-brand hover:underline">Next</button>;
  }
  return originalElement;
}

  export function onShowSizeChange(current, pageSize) {
    // 
  }
